import React from "react";

const Cancellation = () => {
  return (
    <>
      {/* breadcrumb start */}
      <div
        className="cta4-section-area mkt150"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/newbg.png)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="cta-content-area heading1">
                <h2 className="text-anime-style-3">Cancellation Policy</h2>
                <div className="space16" />
                <p>Service Cancellation & Refund Rules</p>
              </div>
            </div>
            <div className="col-lg-3" />
            <div className="col-lg-4">
              <div className="cta-circle-area">
                <div className="img1">
                  <img src="assets/img/all-images/cta/cta-img4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* breadcrumb end */}

      <div className="w-full h4-pricing-wrapper pb-[60px] md:pb-[6rem] max-md:pt-[60px] max-md:px-[20px] md:pt-[100px] pricing_section_bg">
        <div className="theme-container mx-auto">
          <div className="w-full">
            <div className="md:px-[100px]">
              <p>
                We believes in helping its customers as far as possible, and has
                therefore a liberal cancellation policy. Under this policy:
              </p>
              <ul>
                <li>
                  1. Cancellations will be considered only if the request is
                  made within 7 days of placing the order. However, the
                  cancellation request may not be entertained if the orders have
                  been communicated to the vendors/merchants and they have
                  initiated the process of shipping them.
                </li>
                <li>
                  2. We does not accept cancellation requests for orders already
                  initiated or in transit or completed. However,
                  refund/replacement can be made if the customer establishes
                  that the quality of product/service delivered is not good.
                </li>
                <li>
                  3. In case of improper delivery of services or inaccurate
                  results, please report the same to our Customer Service team.
                  The request will, however, be entertained once the health
                  provider has checked and determined the same at his own end.
                  This should be reported within 7 days of receipt of the
                  product/service.
                </li>
                <li>
                  4. In case you feel that the product/service received is not
                  as promised by us or as per your expectations, you must bring
                  it to the notice of our customer service within 7 days of
                  receiving the product/service. The Customer Service Team after
                  looking into your complaint will take an appropriate decision.
                </li>
                <li>
                  5. In case of any Refunds approved by us, it’ll take 6-8 days
                  for the refund to be processed to the end customer.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cancellation;
